import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@client/components/coming-soon";
import { useTranslation } from "react-i18next";

function DatabaseSettingsPage() {
  const { t } = useTranslation("systemSettings");
  return (
    <ComingSoon message={t("comingSoon.database")} />
  );
}

export const Route = createFileRoute("/_app/settings/database")({
  component: DatabaseSettingsPage,
});
